import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';


import "./Slideshow.css"
import { Slide } from 'react-slideshow-image';


import TextTransition, { presets } from "react-text-transition";
import TextLoop from "react-text-loop";

import styled from 'styled-components';

import Slide_1 from "./images/GABS.jpg";
import Slide_2 from "./images/lob.jpg";
import Slide_3 from "./images/slidepic.jpg";
import Slide_4 from "./images/crowd.jpg";
import backgroundPic from "./images/headphones.jpg";
import { Link } from "react-router-dom";

import Footer from "./Footer"
import MediaPlayer from "./MediaPlayer";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  title: {
    flexGrow: 1,
    textAlign: 'start',
    color:"#FFF"
  },
  appBar:{
    background:"transparent",
    elevation:0
  },
  myTabs:{
    textAlign:"end",
    padding:20
  },
  tabButns:{
    border:"transparent",
    color:"#FFF"
  },
  headerBackground:{
    background: `url(${backgroundPic}) no-repeat`,
    backgroundSize: "cover",

  },
  textOnSlideShow:{
    textAlign:"center",
    color:"#FFF",
    alignContent:"center",
    alignItems:"center",
    
  }
 
}));

const slideImages = [
  Slide_1,
  Slide_2,
  Slide_3,
  Slide_4,
];

const TEXTS = [
  "THE BEST MUSIC IN TOWN",
  "EXCLUSIVE PLAYLISTS",
  "LET THE MUSIC TAKE CONTROL",
  "LISTEN TO EXCLUSIVE JAMS!!"
];

const SECTEXTS = [
  "THE FUN DON'T STOP",
  "EXCLUSIVE PLAYLISTS",
  "K-BRIELLY JAMS ON THE LOOP",
  "LISTEN TO EXCLUSIVE JAMS!!"
];

const StyledButton = styled.button`
color: white;
	padding: 5px;
	border: 1px;
	background: none;
  font-size: 1em;
  margin: 5px 10px 0px;

	&:hover {
		background: none;
    color: purple;
    cursor:pointer;
	}
`;

function Stream() {
  const classes = useStyles();
  const [index, setIndex] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() =>
      setIndex(index => index + 1),
      3000 // every 3 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);

 

  return (
    <div className={classes.root}>
      <Grid container  >
        <Grid item xs={12} className={classes.headerBackground}>
        <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            K-BRIELLY MUSIC
          </Typography>
        </Toolbar>
      </AppBar>
      <div className={classes.myTabs}>
        <StyledButton
        onClick={()=>{
          window.location.href="/"
        }}
          onMouseEnter={()=>{
            console.log("color")
          }}>
          HOME
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/stream"
        }}
        >
          STREAM
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/music"
        }}
        >
          MUSIC
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/videos"
        }}
        >
          VIDEOS
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/contacts"
        }}
        >
          CONTACT
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/about"
        }}
        >
          ABOUT
        </StyledButton>
        <StyledButton
        onClick={()=>{
          window.location.href="/"
        }}
        >
          BLOG
        </StyledButton>
      </div>
      <hr></hr>
        </Grid>
        <Grid item xs={12} style={{background:"black"}}>
        <Slide easing="ease" >
          <div className="each-slide">
            <div  style={{'backgroundImage': `url(${slideImages[0]})`}}>
            <Grid container justify="center"  >
              <Grid item xs={12} className={classes.textOnSlideShow}>
              <span>
              <h1>
                  <TextTransition
                    delay={2}
                    inline={true}
                    text={ TEXTS[index % TEXTS.length] }
                    springConfig={ presets.slow }
                  />
                </h1>
              </span>
              <h2>
                <TextLoop>
                    <span>Greatest hits</span>
                    <Link to="/music">Play the music</Link>
                </TextLoop>{" "}
                for the soul.
            </h2>
              </Grid>
            </Grid>
            </div>
          </div>

          <div className="each-slide">
            <div style={{'backgroundImage': `url(${slideImages[1]})`}}>
            <Grid container justify="center" >
              <Grid item xs={12} className={classes.textOnSlideShow}>
              <span >
              <h1>
                  <TextTransition
                    delay={2}
                    inline={true}
                    text={ SECTEXTS[index % TEXTS.length] }
                    springConfig={ presets.slow }
                  />
                </h1>
              </span>
              <h2>
                <TextLoop>
                    <span>One Click Away From</span>
                    <Link to="/music">Go Watch</Link>
                </TextLoop>{" "}
                K-Brielly Music Videos.
            </h2>
              </Grid>
            </Grid>
              
            </div>
          </div>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${slideImages[2]})`}}>
            <Grid container justify="center"  >
              <Grid item xs={12} className={classes.textOnSlideShow}>
              <span>
              <h1>
                  <TextTransition
                    style={{color:"black"}}
                    delay={2}
                    inline={true}
                    text={ TEXTS[index % TEXTS.length] }
                    springConfig={ presets.slow }
                  />
                </h1>
              </span>
              <h2 style={{color:"black"}}>
                <TextLoop>
                    <span>Greatest hits</span>
                    <Link to="/music">Play the music</Link>
                </TextLoop>{" "}
                for the soul.
            </h2>
              </Grid>
            </Grid>
            </div>
          </div>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${slideImages[3]})`}}>
            <Grid container justify="center"  >
              <Grid item xs={12} className={classes.textOnSlideShow}>
              <span>
              <h1>
                  <TextTransition
                    style={{color:"black"}}
                    delay={2}
                    inline={true}
                    text={ TEXTS[index % TEXTS.length] }
                    springConfig={ presets.slow }
                  />
                </h1>
              </span>
              <h2 style={{color:"black"}}>
                <TextLoop>
                    <span>Greatest hits</span>
                    <Link to="/music">Play the music</Link>
                </TextLoop>{" "}
                for the soul.
            </h2>
              </Grid>
            </Grid>
            </div>
          </div>
        </Slide>
        <Grid item xs={12} >
          <MediaPlayer/>
        </Grid>
        <Grid item xs={12} >
          <Footer/>
        </Grid>
        </Grid>
        </Grid>
      
    </div> 
  );
}

export default Stream;
